/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Anuluj',
    CONFIRM: 'Potwierdzenie',
    SAVE: 'Zapisz',
    SEARCH: 'Wyszukiwanie'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Data zakończenia',
    MEMBER_ID: 'Identyfikator członka',
    NAME: 'Nazwa'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Dodaj członków',
    CREATE_MEMBER: 'Dodaj członka',
    DELETE_MEMBER_MODAL_TITLE: 'Usuń członka',
    EDIT_MEMBER: 'Edytuj członka',
    EMAIL: 'E-mail',
    END_DATE: 'Data zakończenia',
    MEMBERS: 'Partnerzy',
    NAME: 'Nazwa',
    NO: 'Nie',
    YES: 'Tak'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Czy na pewno chcesz wyeliminować partnera?',
    NO_MEMBER_NAME_EMAIL: 'Brak nazwy i/lub adresu e-mail',
    NO_MEMBER_NAME_EMAIL_DETAIL:
      'Wprowadź swoje imię i nazwisko i/lub adres e-mail',
    NO_ROWS_MEMBERS: 'Brak członków',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Zmiana kryteriów wyszukiwania'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Partner pomyślnie wyeliminowany',
    MEMBER_DETAILS_SAVED: 'Członek został pomyślnie zapisany',
    SUCCESS: 'Sukces'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Edytuj członka',
    EMAIL: 'E-mail',
    END_DATE: 'Data zakończenia',
    MEMBER_ID: 'Identyfikator członka',
    NAME: 'Nazwa',
    REMOVE_MEMBER: 'Usuń członka'
  }
};
